// BM Sürdürülebilir Kalkınma Amaçları (https://sdgs.un.org/goals) — resmi Türkçe adlar
export default [
  { goal: 1, title: 'Yoksulluğa Son' },
  { goal: 2, title: 'Açlığa Son' },
  { goal: 3, title: 'Sağlıklı ve Kaliteli Yaşam' },
  { goal: 4, title: 'Nitelikli Eğitim' },
  { goal: 5, title: 'Toplumsal Cinsiyet Eşitliği' },
  { goal: 6, title: 'Temiz Su ve Sanitasyon' },
  { goal: 7, title: 'Erişilebilir ve Temiz Enerji' },
  { goal: 8, title: 'İnsana Yakışır İş ve Ekonomik Büyüme' },
  { goal: 9, title: 'Sanayi, Yenilikçilik ve Altyapı' },
  { goal: 10, title: 'Eşitsizliklerin Azaltılması' },
  { goal: 11, title: 'Sürdürülebilir Şehirler ve Topluluklar' },
  { goal: 12, title: 'Sorumlu Üretim ve Tüketim' },
  { goal: 13, title: 'İklim Eylemi' },
  { goal: 14, title: 'Sudaki Yaşam' },
  { goal: 15, title: 'Karasal Yaşam' },
  { goal: 16, title: 'Barış, Adalet ve Güçlü Kurumlar' },
  { goal: 17, title: 'Amaçlar için Ortaklıklar' },
]
